import { DateTime } from 'luxon';
/**
 * Determines whether data for intent analysis for a given campaign is ready to be used.
 * The smallest unit of time we operate on is a week.
 *
 * Returns true for the following week if the campaign has been in the database at least since Saturday.
 * There is no benefit to users if we restrict access to data if the campaign hasn't started yet.
 *
 * E.g.:
 * - was created on Monday 09.05, we'll show data Monday 16.05
 * - was created on Friday 06.05, we'll show data Monday 09.05
 * - was created on Tuesday 10.05, we'll show data 16.05
 * - was created on Friday 13.05, we'll show data 16.05
 * - was created on Sunday 15.05, we'll show data 23.05
 */
export const isIntentAnalysisDataAvailable = (campaignCreatedDate) => {
    const now = DateTime.utc().startOf('day');
    const whenWillBeAvailable = DateTime.fromISO(whenWillIntentDataBeAvailable(campaignCreatedDate), { zone: 'utc' }).startOf('day');
    if (now >= whenWillBeAvailable) {
        return true;
    }
    return false;
};
export const whenWillIntentDataBeAvailable = (campaignCreatedDate) => {
    const createdDate = DateTime.fromISO(campaignCreatedDate, {
        zone: 'utc',
    }).startOf('day');
    /**
     * If campaign was created on Sunday, the data won't be available until next week.
     * Processing cutoff is Sunday 00:00AM
     */
    if (createdDate.weekday === 7) {
        return createdDate.plus({ day: 14 }).startOf('week').toISO();
    }
    return createdDate.plus({ day: 7 }).startOf('week').toISO();
};
//# sourceMappingURL=isIntentAnalysisDataAvailable.js.map